import React from 'react';
import { ApplicationSettingEditTemplate } from 'themes/application/application-setting/components';
import { observer } from 'mobx-react';
import { ApplicationSettingEditViewStore } from 'application/application-setting/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ApplicationSettingEditViewStore(rootStore, componentProps), 'editView')
@observer
class ApplicationSettingEdit extends React.Component {
    render() {
        return <ApplicationSettingEditTemplate {...this.props} />
    }
}

export default ApplicationSettingEdit;